import { useState, useEffect, useContext } from 'react'
import styled from 'styled-components'
import { variant } from 'styled-system'
import PropTypes from 'prop-types'
import moment from 'moment'

import { Row } from '../Grid'
import { Text } from '../Text'
import { FilledInfo } from '../Icons'
import { theme } from '../../../utils/theme'

import { getProfile } from 'services/auth'
import TimezoneContext from '../../../context/timezoneContext'

const InnerNotification = ({ dataType, selectedDate, variant }) => {
  const [text, setText] = useState('')
  const [backgroundColor, setBackgroundColor] = useState('')
  const [isVisible, setIsVisible] = useState(false)
  const { timezone } = useContext(TimezoneContext)

  const user = getProfile()

  useEffect(() => {
    if (dataType === 'billet-notice') {
      setBackgroundColor(theme.colors.gray.n400)
    }
  }, [])

  useEffect(() => {
    if (!selectedDate) {
      return setIsVisible(false)
    }

    try {
      const showConsultationValue = !user?.contract?.features?.hide_consultation_value
      const isDataTypeBilletNotice = dataType === 'billet-notice'

      if (isDataTypeBilletNotice && showConsultationValue) {
        const sessionNextBankDate = sessionStorage.getItem('next_bank_date')
        const nextBankDate = moment(sessionNextBankDate)
        const bankSlipYearMonthDay = nextBankDate.format('YYYYMMDD')
        const bankSlipTime = nextBankDate.format('HH:mm')
        const formattedBankDay = nextBankDate.format('DD')
        const formattedBankMonth = nextBankDate.format('MMM')

        sessionStorage.setItem('bank_slip_day', bankSlipYearMonthDay)
        sessionStorage.setItem('bank_slip_time', bankSlipTime)
        sessionStorage.setItem('bank_formated_month', formattedBankMonth)

        setText(
          `Esse horário não pode ser pago com boleto, se quiser usar esse meio de pagamento selecione um horário a partir das ${bankSlipTime} de ${formattedBankDay} ${formattedBankMonth}.`
        )

        const parsedSelectedDate = moment(selectedDate, 'YYYYMMDDHH:mm')

        const selectedDateIsBeforeBankSlipDate = parsedSelectedDate.isBefore(nextBankDate)

        if (selectedDateIsBeforeBankSlipDate) {
          return setIsVisible(true)
        }
        setIsVisible(false)
      }
    } catch (error) {
      console.log(error)
    }
  }, [selectedDate, timezone])

  if (isVisible) {
    return (
      <NotificationBox background={backgroundColor} variant={variant}>
        <Row>
          <FilledInfo color={backgroundColor} size='20px' />
        </Row>
        <NotificationText variant='small' textAlign='left' color='white'>
          {text}
        </NotificationText>
      </NotificationBox>
    )
  }

  return <></>
}

InnerNotification.defaultProps = {
  variant: ''
}
InnerNotification.propTypes = {
  variant: PropTypes.string
}

const NotificationBox = styled(Row)(
  () => `
  align-items: center;
  border-radius: 4px;
  padding: 16px;
  width: 100%;
  align-self: flex-end;
`,
  variant({
    variants: {
      inSearchCard: {
        marginRightVide: '0',
        marginTop: '10px',
        maxHeight: '75px'
      },
      inSearchCard: {
        marginRight: '40px',
        marginTop: '10px',
        maxHeight: '75px'
      },
      inCalendar: {
        marginTop: '10px'
      },
      postEvaluation: {
        marginY: '20px',
        alignSelf: 'center'
      }
    }
  })
)

const NotificationText = styled(Text)`
  margin-left: 20px;
`

export default InnerNotification
